import { render, staticRenderFns } from "./PaymentApprovedModal.vue?vue&type=template&id=1047cd83&scoped=true"
import script from "./PaymentApprovedModal.vue?vue&type=script&lang=js"
export * from "./PaymentApprovedModal.vue?vue&type=script&lang=js"
import style0 from "./PaymentApprovedModal.vue?vue&type=style&index=0&id=1047cd83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1047cd83",
  null
  
)

export default component.exports